module.exports = __webpack_public_path__ + "static/media/asagi.08e78cc9.png";